import { render, staticRenderFns } from "./xieZuoZhiDao.vue?vue&type=template&id=2ca6b968&scoped=true&"
import script from "./xieZuoZhiDao.vue?vue&type=script&lang=js&"
export * from "./xieZuoZhiDao.vue?vue&type=script&lang=js&"
import style0 from "./xieZuoZhiDao.vue?vue&type=style&index=0&id=2ca6b968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6b968",
  null
  
)

export default component.exports